import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { HeaderFeature } from '@app/src/common/header';
import { ListMyPackageFeature } from '@app/src/views/MyPackage/listMyPackage';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

export const MyPackage: React.FC = () => {
  const history = useHistory();
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (userStorage && !userStorage.jwt || !userStorage) {
      history.push('/inicia-tu-sesion');
    }
  }, []);

  return (
    <React.Fragment>
      <HeaderFeature />
      <ListMyPackageFeature />
      <MiniFooter />
    </React.Fragment>
  )
};
